/**
 * The route table, assembled from feature route modules.
 *
 * This file may only import `routes` barrels — never a page component. That
 * constraint is the whole point: the project this one learned from grew a
 * 789-line App.tsx holding every lazy import and every <Route>, and by then it
 * was nobody's file to clean up.
 *
 * Public routes first, then everything inside the authenticated shell, then
 * the catch-all. A new feature is one import and one spread.
 */
import { createElement } from 'react';
import type { RouteObject } from 'react-router';

import { authProtectedRoutes, authRoutes } from '@/features/auth/routes';
import { homeRoutes } from '@/features/home';
import { productObservationsRoutes } from '@/features/productObservations';
import { sunatCommunicationBatchesRoutes } from '@/features/sunatCommunicationBatches';
import { NotFound } from '@/shared/components/NotFound';
import { AppShell } from '@/shared/layout/AppShell';

export const routes: RouteObject[] = [
  ...authRoutes,
  {
    element: createElement(AppShell),
    children: [
      ...homeRoutes,
      ...productObservationsRoutes,
      ...sunatCommunicationBatchesRoutes,
      ...authProtectedRoutes,
    ],
  },
  { path: '*', element: createElement(NotFound) },
];
